import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

import FooterNetwork from "./FooterNetwork";

import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
} from "react-icons/fa";

import Logo from "../../assets/logo.png";
import "./Footer.css";

const Footer = () => {
  const { lang } = useLanguage();

  const labels = {
    sq: {

       slogan: "Teknologji. Zgjidhje. Besim.",
      description:
        "Teknologji. Zgjidhje. Besim. Jemi këtu për t’ju ofruar më të mirën çdo ditë.",

      quickLinks: "Linket e shpejta",
      contact: "Kontakt",
      workingHours: "Orari i punës",

      home: "Kreu",
      products: "Produktet",
      services: "Shërbimet",
      about: "Rreth nesh",
      contactPage: "Kontakt",

      mondaySaturday: "E Hënë – E Shtunë",
      sunday: "E Diel",
      closed: "Pushim",

      privacy: "Politika e Privatësisë",
      terms: "Kushtet e Përdorimit",

      rights: "Të gjitha të drejtat e rezervuara",
      address: "Rruga e Kavajës 133, Tiranë",
    },

    en: {
      slogan: "Technology. Solutions. Trust.",
      description:
        "Technology. Solutions. Trust. We are here to offer you the best every day.",

      quickLinks: "Quick Links",
      contact: "Contact",
      workingHours: "Working Hours",

      home: "Home",
      products: "Products",
      services: "Services",
      about: "About Us",
      contactPage: "Contact",

      mondaySaturday: "Monday – Saturday",
      sunday: "Sunday",
      closed: "Closed",

      privacy: "Privacy Policy",
      terms: "Terms of Use",

      rights: "All rights reserved",
      address: "Kavaja street 133, Tiranë",
    },
  };

  const text = lang === "sq" ? labels.sq : labels.en;

  return (
    <footer className="design-footer">
      {/* NETWORK BACKGROUND */}
      <FooterNetwork />

      {/* MAIN FOOTER */}
      <div className="design-footer-main">
        {/* COMPANY */}
        <div className="design-footer-brand">
          <Link to="/" className="design-footer-logo-link">
            <img
              src={Logo}
              alt="Master Sol&TECH"
              className="design-footer-logo"
            />

            <div className="design-footer-brand-text">
              <strong>
                MASTER <span>SOL&amp;TECH</span>
              </strong>

            <small>{text.slogan}</small>
            </div>
          </Link>

          <p>{text.description}</p>

          <div className="design-footer-socials">
            <a
              href="https://facebook.com/masterphonemobile"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://instagram.com/mastersoltech.al?igsh=MXE0cDVucHBjNWRiOQ=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.tiktok.com/@masterphone_shop_tirana?_r=1&_t=ZS-98bNw4VCuwL"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <FaTiktok />
            </a>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="design-footer-column">
          <h3>{text.quickLinks}</h3>

          <Link to="/">{text.home}</Link>
          <Link to="/shop">{text.products}</Link>
          <Link to="/service">{text.services}</Link>
          <Link to="/about">{text.about}</Link>
          <Link to="/contact">{text.contactPage}</Link>
        </div>

        {/* CONTACT */}
        <div className="design-footer-column design-footer-contact">
          <h3>{text.contact}</h3>

          <a href="tel:+355688188188">
            <FaPhoneAlt />
            <span>068 818 8188</span>
          </a>

          <a href="mailto:info@mastersoltech.com">
            <FaEnvelope />
            <span>info@mastersoltech.com</span>
          </a>

          <div>
            <FaMapMarkerAlt />
            <span>{text.address}</span>
          </div>
        </div>

        {/* WORKING HOURS */}
        <div className="design-footer-column design-footer-hours">
          <h3>{text.workingHours}</h3>

          <div className="working-day">
            <span>{text.mondaySaturday}</span>
            <strong>09:00 – 20:00</strong>
          </div>

          <div className="working-day">
            <span>{text.sunday}</span>
            <strong>{text.closed}</strong>
          </div>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="design-footer-bottom">
        <div className="design-footer-bottom-inner">
          <p>
            © {new Date().getFullYear()} Master Sol&amp;TECH. {text.rights}.
          </p>

          <div className="design-footer-legal">
            <Link to="/privacy">{text.privacy}</Link>
            <span />
            <Link to="/terms">{text.terms}</Link>
          </div>
        </div>
      </div>

      {/* WHATSAPP */}
      <a
        href="https://wa.me/355688188188"
        target="_blank"
        rel="noopener noreferrer"
        className="design-footer-whatsapp"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </a>
    </footer>
  );
};

export default Footer;